import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  id: "root",
  combinator: "and",
  rules: [],
};

export const querySlice = createSlice({
  name: "query",
  initialState,
  reducers: {
    setQuery: (state, action) => {
      state.id = action.payload.id;
      state.combinator = action.payload.combinator;
      state.rules = action.payload.rules;
    },
    clearQuery: (state) => {
      state.id = "root";
      state.combinator = "and";
      state.rules = [];
    },
  },
});

export const { setQuery, clearQuery } = querySlice.actions;
export default querySlice.reducer;
